import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import HeadCashes from "./headCashes";
import DetailCashMovements from "./detailCashMovements";
import { ErrorModal } from "../../components/ModalAlert";
import supabase from "../../supabase";
import { LoaderSpinner } from "../../components/spinner/loader";
import { MuiTheme, textLabels } from "../../styles/MuiOverrideStyles";

const empty = (value) => value === undefined || value === null || value === '';

const CashMovements = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [usedBalance, setUsedBalance] = useState(0);
  const [description, setDescription] = useState('');
  const [amountToWithdraw, setAmountToWithdraw] = useState('');
  const [cashIdSelected, setCashIdSelected] = useState('');
  const [cashId] = useState(1);
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [checks, setChecks] = useState([]);
  const [cashes, setCashes] = useState([]);
  const [balance, setBalance] = useState('');
  const [cashesMovements, setCashesMovements] = useState([]);
  const [selectedChecksNumbers, setSelectedChecksNumbers] = useState('');
  const [cashTypeId, setCashTypeId] = useState('');
  const [searchText, setSearchText] = useState(location?.state?.searchRecibo || '');
  const [fechaDesde, setFechaDesde] = useState(location?.state?.fechaDesde || '');

  useEffect(() => {
    if (location?.state?.searchRecibo) {
      setSearchText(location.state.searchRecibo);
    }
    if (location?.state?.fechaDesde) {
      setFechaDesde(location.state.fechaDesde);
    }
  }, [location?.state?.searchRecibo, location?.state?.fechaDesde]);

  // Simular tiempo de carga inicial para mostrar el spinner
  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleAmountToWithdrawChange = (newAmountToWithdraw) => setAmountToWithdraw(newAmountToWithdraw);
  const handleCashIdSelectedChange = (newCashIdSelected) => setCashIdSelected(newCashIdSelected);
  const handleDescriptionChange = (newDescription) => setDescription(newDescription);
  const handleCashTypeIdChange = (newCashTypeId) => setCashTypeId(newCashTypeId);

  const allInputsValid = () => {
    return amountToWithdraw > 0 && description !== '' && cashIdSelected !== '';
  };

  const saveOperation = async () => {
    setLoading(true);
    if (allInputsValid()) {
      try {
        const amountValue = parseFloat(amountToWithdraw) * -1;

        const cashMovementsToInsert = {
          amount: amountValue,
          description: selectedChecksNumbers ? `${description} [ ${selectedChecksNumbers} ]` : description,
          paymentMethod: -Number(cashIdSelected),
          createdAt: new Date(),
          cashId: cashIdSelected
        };

        await supabase
          .from("cashMovements")
          .insert(cashMovementsToInsert);

        const { data: cashData } = await supabase
          .from("cash")
          .select("balance")
          .eq("cashId", cashIdSelected)
          .single();

        const updatedBalance = parseFloat(cashData.balance) + amountValue;

        await supabase
          .from("cash")
          .update({ balance: updatedBalance })
          .eq("cashId", cashIdSelected);

      } catch (error) {
        ErrorModal({ title: "Error", text: error.message });
      } finally {
        setLoading(false);
      }
      window.location.reload();
    } else {
      ErrorModal({ title: "Error", text: "Por favor, complete todos los campos obligatorios." });
      setLoading(false);
    }
  };

  const options = {
    filterType: "checkbox",
    responsive: "simple",
    selectableRows: "none",
    searchOpen: true,
    searchText: searchText,
    textLabels: textLabels,
    onSearchChange: (searchText) => {
      setSearchText(searchText);
    }
  };

  return (loading || initialLoading) ? (
    <div
      style={{
        width: "100%",
        height: "200px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoaderSpinner />
    </div>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        width: "100%",
      }}
    >
      <HeadCashes />
      <DetailCashMovements
        onCashIdSelectedChange={handleCashIdSelectedChange}
        onAmountToWithdrawChange={handleAmountToWithdrawChange}
        onDescriptionChange={handleDescriptionChange}
        onCashTypeIdChange={handleCashTypeIdChange}
        allInputsValid={allInputsValid}
        setSelectedChecksNumbers={setSelectedChecksNumbers}
        searchText={searchText}
        setSearchText={setSearchText}
        fechaDesde={fechaDesde}
        setFechaDesde={setFechaDesde}
        isLoading={loading}
      />
      <Box>
        <Button variant="outlined" onClick={() => navigate(-1)} sx={{ minHeight: 44 }}>
          Volver
        </Button>
      </Box>
    </Box>
  );
};

export default CashMovements;